<template>
  <div class="hp-manager-page-list">
    <filter-form :filter='filter' @handleSubmit="handleSubmit" ref="filter">
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize=15 :dataSource="datas"
      :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a :disabled="!permissionChecker('Freight.Delete')" @click="deldata(rowKey.data)">删除</a>
        </span>
      </template>
      <template slot="picShow" slot-scope="rowKey">
        <div style="width: 50px; height: 50px">
          <img v-for="item in rowKey.data.imgUrl.split(',')" :src="item + '?height=50&width=50'" alt="" :key="item"
            @click="ClickImg(item)" />
        </div>
      </template>
    </standard-table>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img style="width: 100%; padding: 15px" :src="previewImage" />
    </a-modal>
  </div>

</template>

<script>
import { api } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {},
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "deliveryOrderNo",
          name: "出库单号"
        },
        {
          type: "input",
          key: "dealerName",
          name: "经销商"
        },
        {
          type: "dateFilter",
          key: "deliveryDate",
          name: "上传时间"
        },
        {
          type: "input",
          key: "driver",
          name: "司机/车牌"
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 120,
          scopedSlots: { customRender: "action" },
          fixed: "left"
        },
        {
          title: "出库单号",
          width: 150,
          dataIndex: "deliveryNo",
          sorter: true
        },
        {
          title: "经销商",
          width: 150,
          dataIndex: "dealerName",
        },
        {
          title: "出库时间",
          width: 180,
          dataIndex: "deliveryDate",
          customRender: (text, row, index) => {
            return this.formatDate(row.deliveryDate, "YYYY-MM-DD");
          }
        },
        {
          title: "司机",
          width: 150,
          dataIndex: "driverName"
        },
        {
          title: "车牌",
          width: 150,
          dataIndex: "carCard"
        },
        {
          title: "运费金额",
          width: 200,
          dataIndex: "freightAmount"
        },
        {
          title: "图片",
          dataIndex: "imgList",
          width: 80,
          scopedSlots: { customRender: "pic" }
        },
        {
          title: "上传时间",
          width: 180,
          dataIndex: "creationTime",
          customRender: (text, row, index) => {
            return this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        }
      ],
      datas: [],
      filterdata: JSON.parse(JSON.stringify(config.pageFilter)),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      qxParams: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "1300px",
      explain: "",
      visible: false,
      permission: [],
      title: "",
      previewVisible: false,
      previewImage: null
    };
  },
  async mounted() {
    this.permission = this.getPermission("DeliveryOrder");
    this.getDatas(this.filterdata);
  },
  methods: {
    ClickImg(data) {
      console.log(data);
      this.previewImage = data;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleSubmit(p) {
      console.log(p)
      this.pagination.current = 0;
      this.filterdata.deliveryOrderNo = p.values.deliveryOrderNo;
      this.filterdata.driver = p.values.driver;
      this.filterdata.dealerName = p.values.dealerName;
      if (p.values.deliveryDate) {
        this.filterdata.startTime =
          p.values.deliveryDate[0] != null
            ? p.values.deliveryDate[0].valueOf()
            : null;
        this.filterdata.endTime =
          p.values.deliveryDate[1] != null
            ? p.values.deliveryDate[1].valueOf()
            : null;
      }
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      console.log(this.filterdata)
      this.getDatas(this.filterdata);
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.delFreightRecord({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },

    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.filters.code && table.filters.code.length > 0) {
        console.log(table.filters);
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      console.log(options)
      let data = await api.getFreightRecordPaged(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/router/Goods/Freight/Record.vue